import type { EntryPoint, EntryPointComponent } from 'react-relay';

import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

import parameters, {
	type collectionChangePlanPopupQuery,
} from './__generated__/collectionChangePlanPopupQuery.graphql';

export type EntryPointParams = {
	collectionEntitlementId: string;
};

type CollectionChangePlanPopupComponent = EntryPointComponent<
	{
		collectionChangePlanPopupQuery: collectionChangePlanPopupQuery;
	},
	Record<string, never>,
	{
		onClose: (extraInformation?: unknown) => void;
	},
	Record<string, never>
>;

export const entryPoint: EntryPoint<CollectionChangePlanPopupComponent, EntryPointParams> =
	createEntryPoint({
		root: JSResourceForInteraction<CollectionChangePlanPopupComponent>(
			/* webpackChunkName: "@atlaskit-internal_edition-awareness-collection-change-plan-popup" */ './collection-change-plan-popup',
			{
				moduleId: 'edition-awareness-collection-change-plan-popup',
			},
		),
		getPreloadProps: ({ collectionEntitlementId }: EntryPointParams) => ({
			entryPoints: {},
			extraProps: {},
			queries: {
				collectionChangePlanPopupQuery: {
					parameters,
					variables: {
						collectionEntitlementId,
					},
				},
			},
		}),
	});
